import { KEY_USER_FINGERPRINT } from '@mygpt/app/apis';
import { getStorageValue, setStorageValue } from './storage';

// 生成SHA-1哈希
async function sha1(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-1', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  // 取前16位（8个字节）
  return hashArray
    .slice(0, 8)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

// 获取更多浏览器特征信息
function getBrowserFeatures(): string[] {
  const features = [
    navigator.userAgent,
    navigator.language,
    `${window.screen.width}x${window.screen.height}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.hardwareConcurrency,
    (navigator as any).deviceMemory,
    Array.from(navigator.plugins)
      .map((p) => p.name)
      .join(','),
    // 添加更多特征
    navigator.platform,
    navigator.vendor,
    window.devicePixelRatio,
    navigator.maxTouchPoints,
    // 网络信息
    (navigator as any).connection?.effectiveType,
    (navigator as any).connection?.rtt,
    (navigator as any).connection?.downlink,
    // 添加Canvas指纹
    getCanvasFingerprint(),
    // 添加WebGL指纹
    getWebGLFingerprint(),
  ].filter(Boolean); // 过滤掉undefined值

  return features;
}

// 获取Canvas指纹
function getCanvasFingerprint(): string {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  canvas.width = 200;
  canvas.height = 200;

  // 绘制一些文本和图形
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillStyle = '#f60';
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = '#069';
  ctx.fillText('Canvas Fingerprint', 2, 15);
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
  ctx.fillText('Canvas Fingerprint', 4, 17);

  return canvas.toDataURL();
}

// 获取WebGL指纹
function getWebGLFingerprint(): string {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  if (!gl) return '';

  const debugInfo = (gl as WebGLRenderingContext).getExtension('WEBGL_debug_renderer_info');
  if (!debugInfo) return '';

  return (gl as WebGLRenderingContext).getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) as string;
}

// 生成浏览器指纹hash值，并保存到所有可用的存储中
export const getBrowserFingerprint = async (): Promise<string> => {
  // 尝试从所有存储中获取已存在的指纹
  const existingFingerprint = getStorageValue(KEY_USER_FINGERPRINT);
  if (existingFingerprint) {
    return existingFingerprint;
  }

  // 获取所有特征信息
  const features = getBrowserFeatures();

  // 添加时间戳和随机数
  const timestamp = Date.now();
  const random = Math.random();

  // 组合所有信息
  const info = [...features, timestamp, random].join('###');

  // 使用SHA-1生成指纹（16位）
  const fingerprint = await sha1(info);

  // 保存到所有可用的存储中
  setStorageValue({
    key: KEY_USER_FINGERPRINT,
    value: fingerprint,
  });

  return fingerprint;
};
